import React, { Fragment } from 'react'
import { withTheme } from 'react-jss'
import { withTranslation } from 'react-i18next'
import classNames from 'classnames'
import compose from '@shopify/react-compose'

import { Button } from '@portal/kit/pkg/components'

import { ONE_DAY } from 'helpers/date'

import styles from './alert-style'

const AlertView = ({ endDate, theme, t }) => {
  if (!endDate) return null

  const dayBeforeExpiration = Math.round(Math.abs((new Date(endDate) - new Date()) / ONE_DAY));

  if (dayBeforeExpiration > 15) return null

  const classes = styles(theme)
  return (
    <Fragment>
      <hr className={classes.separator} />
      <div className={classes.container}>
        <p className={classNames(classes.text, { [classes.textError]: dayBeforeExpiration < 7 })}>
          {t('ran_activate.expire_in_days', { days: dayBeforeExpiration }) }
        </p>
        <Button to="/offers">{t('ran_activate.renew')}</Button>
      </div>
    </Fragment>
  )
}

export default compose(
  withTheme,
  withTranslation(),
)(AlertView)
